<template>
  <div>
    <van-sticky>
      <navbar :title="title" />
      <van-search
        v-model="form.search"
        placeholder="请输入搜索关键词"
        @search="onSearch"
      ></van-search>
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="form.status"
          :options="status"
          @change="onSearch"
        />
      </van-dropdown-menu>
    </van-sticky>

    <van-list
      v-model="list.loading"
      :finished="list.finished"
      finished-text="没有更多了"
      @load="onLoad"
      offset="60"
      style="padding-bottom: 50px"
      class="list-content"
    >
      <div
        class="item-list"
        v-for="item in list.list"
        :key="item.id"
        @click="reviewDetails(item.id)"
      >
        <div class="product-bh-cont">
          <van-icon name="todo-list-o" />
          <span class="product-bh">订单编号:{{ item.order_code }}</span>
        </div>
        <div class="text-title">生产编号：{{ item.dr_code }}</div>
        <div class="text-title">单位名称：{{ item.client_name }}</div>
        <div class="text-price">
          <span>订单类型：{{ order_type[item.order_type] }}</span>
          <span>交货日期：¥{{ item.deliver_date }}</span>
        </div>
        <div class="text-time">下单日期：{{ item.initiate_date }}</div>
        <van-tag
          class="item-tag"
          plain
          :type="tagPrimary[item.status].value"
          >{{ tagPrimary[item.status].text }}
          </van-tag>
      </div>
    </van-list>

    <van-tabbar v-model="activeName">
      <van-tabbar-item name="list" icon="clock-o" to="/drawing"
        >生产列表</van-tabbar-item
      >
      <van-tabbar-item
        name="approval"
        icon="upgrade"
        to="/drawing/audit"
        >我的审核</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { Toast } from "vant";
import { post } from "@/api/post";

export default {
  components: {
    navbar,
  },
  data() {
    return {
      activeName: "list",
      title: "生产列表",
      order_type: ["简易箱体", "防水箱体", "异形箱体", "E结构框架", "小间距箱体", "产品借用", "交安产品", "其它定制"],
      status: [
        { text: "全部订单", value: null },
        { text: "待制图", value: 0 },
        { text: "制图中", value: 1 },
        { text: "制图完成", value: 2 },
        { text: "待排版", value: 3 },
        { text: "排版中", value: 4 },
        { text: "待生产", value: 5 },
        { text: "生产中", value: 6 },
        { text: "生产完毕待交货", value: 14 },
        { text: "完成", value: 15 },
        { text: "财务审核", value: 18 },
        { text: "终止生产", value: 20 },
      ],
      tagPrimary: [
        { text: "待制图", value: "default" },
        { text: "制图中", value: "primary" },
        { text: "制图完成", value: "primary" },
        { text: "待排版", value: "default" },
        { text: "排版中", value: "primary" },
        { text: "待生产", value: "primary" },
        { text: "生产中", value: "primary" },
        { text: "未知", value: "primary" },
        { text: "未知", value: "primary" },
        { text: "未知", value: "primary" },
        { text: "未知", value: "primary" },
        { text: "未知", value: "primary" },
        { text: "未知", value: "primary" },
        { text: "未知", value: "primary" },
        { text: "生产完毕待交货", value: "success" },
        { text: "完成", value: "success" },
        { text: "未知", value: "primary" },
        { text: "未知", value: "primary" },
        { text: "财务审核", value: "primary" },
        { text: "未知", value: "primary" },
        { text: "终止生产", value: "warning" },
      ],
      form: {
        requestType: "drawing_listData",
        page: 1,
        limit: 10,
        status: null,
        search: "",
      },
      list: {
        list: [],
        loading: false,
        finished: false,
      },
    };
  },
  activated() {
    if (this.$route.params.refresh != true) {
      this.list.list = [];
      this.activeName = "list";
      this.list.finished = false;
      this.form.page = 1;
      this.form.approval_status = 0;
      this.list.user_name = "";
      this.onLoad();
    }
  },
  methods: {
    activated() {
      if (!this.$route.meta.isBack || this.isFirstEnter) {
        this.onLoad();
      }
      this.$route.meta.isBack = false;
      this.isFirstEnter = false;
    },
    onSearch() {
      this.list.list = [];
      this.form.page = 1;
      this.list.finished = false;
      this.onLoad();
    },
    onLoad() {
      post(this.form)
        .then((res) => {
          if (res.obj.rows.length === 0) {
            this.list.finished = true;
          }
          if (this.form.page != 1) {
            this.list.list = this.list.list.concat(res.obj.rows);
          } else {
            this.list.list = res.obj.rows;
          }

          this.form.page += 1;
          this.list.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.list.loading = false;
          this.list.finished = true;
          return Toast.fail("数据异常");
        });
    },
    reviewDetails(id) {
      this.$router.push({
        path: "/drawing/details",
        query: { id: id, p: false },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-content {
  padding: 0 10px;
  .item-list {
    margin: 10px 0;
    padding: 1rem 1.14286rem;
    border-radius: 10px;
    background: #fff;
    position: relative;
    .product-bh-cont {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .product-bh {
        color: #999;
        font-size: 12px;
        margin-left: 5px;
      }
    }
    .text-title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      font-size: 13px;
    }
    .item-tag {
      position: absolute;
      right: 15px;
      bottom: 10px;
    }
    .text-price {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
      span {
        font-size: 12px;
        font-weight: bold;
      }
    }
    .text-time {
      margin-top: 8px;
      font-size: 12px;
      color: #999;
    }
  }
}
</style>
